import { useEffect, useState } from 'react';
import { fetchLocations } from '../services/api';
import { countryNames } from '../constants/countryNames';
import StatusIndicator from './StatusIndicator';
import { AdblockIcon } from './Icons';
import { logger } from '../utils/logger';

function Regions() {
  const [locations, setLocations] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    logger.dev('🌍 useEffect triggered for Regions');
    setIsLoading(true);
    fetchLocations()
      .then(data => {
        logger.dev('🌍 Regions: получены локации', data);
        setError(null);
        setLocations(data);
        setIsLoading(false);
      })
      .catch(err => {
        logger.error('❌ Regions: ошибка при получении локаций', err);
        setError(err.message);
        setIsLoading(false);
      });
  }, []);

  const renderLocations = () => {
    if (isLoading) {
      return (
        <StatusIndicator variant="loading" className="regions__loading" />
      );
    }

    if (error) return <StatusIndicator variant="error" className="regions__error" />;

    if (!locations.length) return <StatusIndicator variant="error" className="regions__error" />;

    return locations.map(loc => {
      const countryName = countryNames[loc.code];
      if (!countryName) return null;

      return (
        <div key={loc.code} className="region-card region-card--single">
          <span className="region-flag region-flag--svg">
            <span className={`fi fi-${loc.code.toLowerCase()} flag-img`}></span>
          </span>
          <div className="region-info">
            <span className="region-country">{countryName}</span>
          </div>
          {loc.adblock && (
            <span className="region-shield" title="Блокировка рекламы на YouTube">
              <AdblockIcon size={18} className="icon--middle" stroke="#FF0000" />
              <span className="region-shield-label">Ad YouTube</span>
            </span>
          )}
        </div>
      );
    });
  };

  return (
    <section className="regions">
      <div className="regions__container">
        <h2 className="regions__title">ДОСТУПНЫЕ ЛОКАЦИИ</h2>
        <p className="regions__subtitle">Выбирайте более оптимальные локации</p>
        <div className="regions__grid" id="regionsGrid">
          {renderLocations()}
        </div>
      </div>
    </section>
  );
}

export default Regions;
